/**
 * 지원하는 트래커 유형
 * @enum {string}
 */
export const TrackerType = {
  GOOGLE: 'GOOGLE',
  GTM: 'GTM',
  FACEBOOK: 'FACEBOOK',
  KAKAO: 'KAKAO',
  NAVER: 'NAVER',
  MOBON: 'MOBON',
};
